<template>
  <b-modal
    ref="mvdbp_kompack"
    dialog-class="!w-full !max-w-[600px]"
    body-class="!p-[32px]"
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    hide-header
  >
    <div
      class="relative"
    >
      <button
        class="absolute top-0 right-0 hover:bg-[#333333]/5 transition-all duration-300 rounded-full flex items-center justify-center"
        @click="handleCloseModal"
      >
        <span class="k-close text-[38px] text-[#333]" />
      </button>
      <h3 class="text-[#333333] text-[24px] font-semibold text-center mb-[24px]">
        Detail Data
      </h3>
      <div id="mvdbp_content">
        <div class="relative w-fit pt-[12px] pr-[12px] mb-[24px]">
          <b-img
            height="88"
            width="88"
            :src="imagePreview"
            @error="handleImageError($event)"
          />
        </div>
        <div class="content">
          <label
            for="mvdbp_content_name"
            class="mb-[8px]"
          >Bahan Packing</label>
          :
          <p>{{ name }}</p>
        </div>
        <div class="content">
          <label
            for="mvdbp_content_name"
            class="mb-[8px]"
          >Satuan</label>
          :
          <p>{{ chargeType }}</p>
        </div>
        <div class="content">
          <label
            for="mvdbp_content_name"
            class="mb-[8px]"
          >Harga</label>
          :
          <p>{{ price }}</p>
        </div>
        <div
          v-if="status === 'pengajuan'"
          class="content"
        >
          <label
            for="mvdbp_content_name"
            class="mb-[8px]"
          >Status</label>
          :
          <span
            class="rounded-full py-[4px] px-[12px] border-solid border-[1px] inline-block text-[12px] font-medium"
            :class="statusLabel.css"
          >
            {{ statusLabel.label }}
          </span>
        </div>
      </div>
      <div
        v-if="isRejected"
        class="mt-[18px]"
      >
        <div class="bg-[#F5F5F5] text-[#333333] rounded-md p-[12px]">
          <p class="mb-[8px]">
            Reason:
          </p>
          <p class="mb-0">
            {{ item.reason || '-' }}
          </p>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { IDR } from '@/libs/currency'
import { ChargeType, PengajuanBahanPackingStatus } from '../config'

export default {
  name: 'ModalViewDetailBahanPacking',
  data() {
    return {
      item: {
        name: '-',
        charge_type: '-',
        price: 'Rp. 0',
        image_url: 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg',
      },
      status: 'konfirmasi',
    }
  },
  computed: {
    name() {
      if (!this.item.name) return '-'
      return this.item.name
    },
    price() {
      if (!this.item.price) return 'Rp. 0'
      return IDR(this.item.price)
    },
    chargeType() {
      if (!this.item.charge_type) return '-'
      return ChargeType[this.item.charge_type]
    },
    imagePreview() {
      if (!this.item.image_url) return 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
      return this.item.image_url
    },
    statusLabel() {
      if (!this.item.submission_status) {
        return {
          label: '-',
          css: 'bg-[#333333] text-[#333333] border-[#333333]',
        }
      }
      return PengajuanBahanPackingStatus[this.item.submission_status]
    },
    isRejected() {
      return this.status === 'pengajuan' && this.item.submission_status === 3
    },
  },
  methods: {
    /**
     * Show modal & initialize data
     * @param {Object} item - Item
     * @param {string} status - Status (pengajuan or konfirmasi)
     */
    show({ item, status }) {
      this.item = item
      this.status = status
      this.$refs.mvdbp_kompack.show()
    },
    handleCloseModal() {
      this.$refs.mvdbp_kompack.hide()
    },
    /**
     * Handle image error so fallback to default image if image not found
     */
    handleImageError(event) {
      const { target } = event
      if (target.dataset.fallback) {
        target.style.display = 'none'
        return
      }
      target.dataset.fallback = 'true'
      target.src = 'https://storage.googleapis.com/komerce/assets/svg/default-image.svg'
    },
  },
}
</script>

<style scoped>
#mvdbp_content  .content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  flex-wrap: wrap;
}
#mvdbp_content label {
  width: 200px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 8px;
}
#mvdbp_content p {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 8px;
}
</style>
